module.exports = __webpack_public_path__ + "img/1-4.9d660864.svg";